import BestaFrameLegsSystemSelectedLegComponent from './BestaFrameLegsSystemSelectedLegComponent';
/**
 * This component is added to the room and holds the selected leg used when
 * creating new frames.
 */
export class FrameSelectedLegComponent {
    constructor(legProductRef, useSupportLeg) {
        this.doStoreInSnapshot = true;
        this.serializable = true;
        this.typeId = BestaFrameLegsSystemSelectedLegComponent.id;
        this.legProductRef = legProductRef;
        this.useSupportLeg = useSupportLeg;
    }
    eq(other) {
        return other.legProductRef === this.legProductRef && other.useSupportLeg === this.useSupportLeg;
    }
    toJson(parse) {
        return parse(JSON.stringify(this));
    }
    serializationKey() {
        return 'FrameSelectedLegComponent';
    }
}
FrameSelectedLegComponent.id = BestaFrameLegsSystemSelectedLegComponent.id;
//# sourceMappingURL=FrameSelectedLegComponent.js.map